import React from "react";
import GATSBY_COMPILED_MDX from "/home/venus_builder/venus-ci/workspace/time-ecomm/master/content/articles/sony-a7cr-review.mdx";
import ArticlePage from '@taboola/venus-core/src/templates/article-template';
ArticlePage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ArticlePage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "2945955164";
